import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import config from './config';

const MOBILE_WIDTH = 768;

export default class AccessibilityBlock extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  };

  state = {
    show: false,
  };

  handleClick = () => {
    const body = document.getElementsByTagName('body')[0];
    const rect = body ? body.getBoundingClientRect() : null;
    if (!rect || rect.width > MOBILE_WIDTH) {
      return;
    }
    this.setState({ show: !this.state.show });
  };

  render() {
    const { onChange, selectedValue, type } = this.props;
    const block = config[type];

    if (!block) {
      return null;
    }
    const rowClassNames = classnames('version_row', { active: this.state.show });

    return (
      <div className={rowClassNames}>
        <div className="version_name" onClick={this.handleClick}>
          <div className="version_title">{block.title}</div>
        </div>
        <div className="version_actions">
          {block.items.map((item, key) => {
            const uniqueKey = `${type}_${item.value}_${key}`;
            return (
              <div
                key={uniqueKey}
                className={classnames(...item.classes, { active: item.value === selectedValue })}
                onClick={() => onChange(type, item.value)}
              >
                {item.name
                  ? item.name
                  : [
                      <span key={`${uniqueKey}_icon`} className={item.iconClasses} />,
                      <span key={`${uniqueKey}_text`} className="version_text">
                        {item.text}
                      </span>,
                    ]}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
